var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"groups"},[_c('h1',[_vm._v(_vm._s(_vm.$t('organizations.groups')))]),_c('users-table',{attrs:{"data":_vm.tableData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }